import { ThemeProvider } from 'styled-components'
import globalTheme from './globalTheme'
import './globalStyles'

export default ThemeProvider
export { globalTheme }



// WEBPACK FOOTER //
// ./src/theme/index.js